import { render, staticRenderFns } from "./PurchaseStatus.vue?vue&type=template&id=12749f39&"
import script from "./PurchaseStatus.vue?vue&type=script&lang=js&"
export * from "./PurchaseStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports